<template>
  <div class="main-head-activity" :style="{'padding-bottom':(currentIndex===0) ? 265+'%' :325+'%'}" v-show="isShow"
       v-loading="loading">
    <div>
      <div class="activity-head">
        <img src="../../../../assets/activity/activity_head.png" alt="">
      </div>
      <!-- 直接跳转 -->
      <router-link :to="{ name : 'LaborList', params : {token:queryParams.token}}">
        <div class="activity-list-button-css" style="margin-right: 0.5%;">查 看 榜 单</div>
      </router-link>
      <div style="position: absolute;top:5.5rem">
        <div class="activity-tab-background" style="position: absolute;z-index: 3">
        </div>
        <div id="activity-tab">
          <ul>
            <li style="" v-on:mouseover="change(index)" :class="[currentIndex==index?'active':'']" :key="item.id"
                v-for="(item,index) in list">{{ item.text }}
            </li>
          </ul>
        </div>
      </div>
      <div
        style="width: 8.95rem;background: rgba(1, 70, 193, 1);position: absolute;z-index: 2;top:7rem;left: 0.5rem; border-radius: 13px 13px 13px 13px;"
        :style="{'height':(currentIndex===0) ? 17.5+'rem' :23.5+'rem'}">
        <div v-if="currentIndex===0">
          <img src="../../../../assets/activity/lobar_date.png" width="70%"
               style="position: absolute;left: 0;right: 0;margin: auto;top: 0.7rem" alt="">
          <div
            style="position: absolute;left: 0;right: 0;margin: auto;top: 2.1rem;color: rgba(33, 229, 239, 100);text-align: center;font-size: 0.35rem">
            2022年4月30日00：00 - 2022年5月4日24:00
          </div>
          <div v-for="(item,index) in rewardList">
        <div style="width: 1.7rem;height:2rem;position: absolute;z-index: 3;top: 5.2rem;" :style="{left: (0.77+1.92*index)+'rem'}">
          <img :src="item.image_url" width="100%"
               style="position: absolute;z-index: 4;margin-top: auto;left: 0;right: 0;text-align: center" alt="">
          <div style="width:80%;padding:0.02rem 0.1rem;position: absolute;left: 0;margin:auto;right: 0;top: 1.57rem;color:rgba(1, 70, 193, 100); font-weight: bold; font-size: 0.3rem;z-index: 4;border: rgba(250, 157, 0, 1) solid 1px ;background-color: rgba(254, 221, 89, 1);text-align: center;border-radius: 1rem;">
            {{ item.name }}
          </div>
        </div>
          </div>
          <img src="../../../../assets/activity/despite.png" width="96%"
               style="position: absolute;left: 0;right: 0;margin: auto;top: 2.9rem" alt="">
          <img src="../../../../assets/activity/lobar_title.png" width="88%"
               style="position: absolute;left: 0;right: 0;margin: auto;top: 2.9rem" alt="">
          <ul id="content-ul"
              style="position: absolute;left: 0;right: 0;margin: auto;top: 8.9rem;color: rgba(31, 220, 236, 100);width: 90%;font-size: 0.35rem;line-height: 0.6rem;">
            <li>1积分=1宝石</li>
            <li>仅活动期间的专属礼物增加积分值：<br>
              <div style="text-indent:1em;">活动礼物“种草莓”（219宝石）</div>
              <div style="text-indent:1em;">活动礼物“买买买”（969宝石）</div>
              <div style="text-indent:1em;">活动礼物“送金砖”（2099宝石）</div>
              <div style="text-indent:1em;">活动礼物“五一出游”（8129宝石）</div>
            </li>
            <li>
              <div style="width: 90%;float: right;margin-right: 0.4rem">所有用户均可参与，在聊天界面送出指定礼物即可累计积分排名。</div>
            </li>
            <br>
            <li>
              <div style="width: 90%;float: right;margin-right: 0.4rem">礼物红人榜=活动期间女性在聊天界面收到男性指定礼物的积分排名。</div>
            </li>
            <br>
            <li>
              <div style="width: 90%;float: right;margin-right: 0.4rem">礼物神豪榜=活动期间男性在聊天界面赠送女性指定礼物的积分排名。</div>
            </li>
            <br>
            <li>
              <div style="width: 90%;float: right;margin-right: 0.4rem">所有奖励均无需手动领取，平台会在活动结束后1个工作日内自动发放。</div>
            </li>
            <br>
          </ul>
        </div>
        <div v-if="currentIndex===1">
          <div class="activity-rule-background-big">
            <!--第一名-->
            <div class="activity-rule-background-int-top"><span
              style="font-size: 0.35rem;color: rgba(255, 255, 255, 100);text-align: center;position: absolute;left: 0;right: 0;margin: auto">第一名</span>
            </div>
            <div style="width: 30%;margin: auto">
              <img src="../../../../assets/activity/gem/first_gem.png" width="84%" alt="">
              <div
                style="color: rgba(53, 248, 252, 100);position: absolute;top: 2.7rem;margin:auto;width:2rem;text-align:center;font-weight: bold;font-size: 0.33rem">
                x30000
              </div>
            </div>
            <div style="width: 30%;margin-left: 1.2rem;float: left;">
              <img v-if="isSex===2" src="../../../../assets/activity/gem/wman_top_box.png" width="92%" alt="">
              <img v-if="isSex===1" src="../../../../assets/activity/gem/man_top_box.png" width="92%" alt="">
            </div>
            <div
              style="float: left;width: 10%;position: absolute;left:0;right:0;top:50%;margin: auto;text-align: center">
              <img src="../../../../assets/activity/gem/plus_sign.png" width="60%" alt="">
            </div>
            <div style="width: 30%;margin-right: 0.8rem;float: right;">
              <img src="../../../../assets/activity/gem/zyp.png" width="92%" alt="">
            </div>
          </div>
          <div class="activity-rule-background-small" style="margin-top: 0.8rem">
            <!--第二名-->
            <div class="activity-rule-background-int-top"><span
              style="font-size: 0.35rem;color: rgba(255, 255, 255, 100);text-align: center;position: absolute;left: 0;right: 0;margin: auto">第二名</span>
            </div>
            <div style="float: left;width: 30%;margin-left: 15%;">
              <img src="../../../../assets/activity/gem/first_gem.png" width="84%" alt="">
              <div style="color: rgba(53, 248, 252, 100);position: absolute;top: 2.65rem;left: 1.67rem;font-weight: bold;font-size: 0.33rem">x20000</div>
            </div>
            <div
              style="float: left;width: 10%;position: absolute;left:0;right:0;top:40%;margin: auto;text-align: center">
              <img src="../../../../assets/activity/gem/plus_sign.png" width="60%" alt="">
            </div>
            <div style="float: right;width: 30%;margin-right: 10%;">
              <img v-if="isSex===2" src="../../../../assets/activity/gem/wman_top_box.png" width="92%" alt="">
              <img v-if="isSex===1" src="../../../../assets/activity/gem/man_top_box.png" width="92%" alt="">
            </div>
          </div>
          <div class="activity-rule-background-small" style="margin-top: 0.8rem">
            <!--第三名-->
            <div class="activity-rule-background-int-top"><span
              style="font-size: 0.35rem;color: rgba(255, 255, 255, 100);text-align: center;position: absolute;left: 0;right: 0;margin: auto">第三名</span>
            </div>
            <div style="float: left;width: 30%;margin-left: 15%;">
              <img src="../../../../assets/activity/gem/first_gem.png" width="84%" alt="">
              <div
                style="color: rgba(53, 248, 252, 100);position: absolute;top: 2.65rem;left: 1.67rem;font-weight: bold;font-size: 0.33rem">
                x10000
              </div>
            </div>
            <div
              style="float: left;width: 10%;position: absolute;left:0;right:0;top:40%;margin: auto;text-align: center">
              <img src="../../../../assets/activity/gem/plus_sign.png" width="60%" alt="">
            </div>
            <div style="float: right;width: 30%;margin-right: 10%;">
              <img src="../../../../assets/activity/gem/zyp.png" width="90%" alt="">
            </div>
          </div>
          <div class="activity-rule-background-small" style="margin-top: 0.8rem">
            <!--第四名-->
            <div class="activity-rule-background-four-top"><span
              style="font-size: 0.35rem;color: rgba(255, 255, 255, 100);text-align: center;position: absolute;left: 0;right: 0;margin: auto">第四至十名</span>
            </div>
            <div style="width: 30%;margin: auto">
              <img src="../../../../assets/activity/gem/first_gem.png" width="84%" alt="">
              <div
                style="color: rgba(53, 248, 252, 100);position: absolute;top: 2.7rem;margin:auto;width:2rem;text-align:center;font-weight: bold;font-size: 0.33rem">
                x2000
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="opacity: 0.8;color:rgba(255, 255, 255, 100);font-size: 0.35rem;text-align: center;font-family: SourceHanSansSC-Medium;position: relative;z-index: 3"
        :style="{'top':(currentIndex===0) ? 24.9+'rem' :30.8+'rem'}">
        本活动最终解释权归官方所有
      </div>
    </div>
  </div>

</template>
<script>
import {isError,userSex} from '../../../../api/activity/activity'

export default {
  name: 'Labor',
  data() {
    return {
      //当前选项卡的索引
      currentIndex: 0,
      // 遮罩层
      loading: true,
      //规则弹框
      ruleDialog: false,
      //参数
      queryParams: {
        token: ""
      },
      isShow: false,
      isSex:2,
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      rewardList: [
        {
          name: '种草莓',
          image_url: require("../../../../assets/activity/gift/labor_gift1.png"),
        },
        {
          name: '买买买',
          image_url: require("../../../../assets/activity/gift/labor_gift2.png"),
        },
        {
          name: '送金砖',
          image_url: require("../../../../assets/activity/gift/labor_gift3.png"),
        },
        {
          name: '五一出游',
          image_url: require("../../../../assets/activity/gift/labor_gift4.png"),
        },
      ],
      //榜单列表
      midAutumnList: [],
      //我的榜单信息
      myDataPojo: {},
      //榜单
      list: [{
        id: '1',
        text: '活动玩法',
      }, {
        id: '2',
        text: '活动奖励',
      }],
      avatar: "../../../../assets/valentine/test.jpeg",
    }

  },
  mounted: function () {
    this.getToken()
    this.isError()
    this.userSex()
  },
  // 方法
  methods: {
    change: function (index) {
      if (this.currentIndex != index) {
        this.currentIndex = index;
      }
    },

    getToken() {
      this.queryParams.token = window.android.getToken();
      // this.queryParams.token = "eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyMDAxMyIsInNleCI6IjEiLCJjcmVhdGVEYXRlIjoxNjExNzk1LCJpc3MiOiJhZG1pbiIsImV4cCI6MTYyNzM0Nzk0NywibmJmIjoxNjExNzk1fQ.xfKchleKjuT0Wf-GWgZOALRlv0637-VMIJ1K3D8C7zk"
      // this.queryParams.token = "eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyMDAwNyIsInNleCI6IjEiLCJjcmVhdGVEYXRlIjoxNjExNzU4LCJpc3MiOiJhZG1pbiIsImV4cCI6MTYyNzMxMDU4MiwibmJmIjoxNjExNzU4fQ.vuIdxVPLdT8s0DPNib89012cO__ttsFQOboFkC6tQxY"
    },

    //是否显示
    isError() {
      this.loading = true
      isError(this.queryParams).then(response => {
        if (response.data) {
          this.isShow = true
        } else {
          this.bus.$emit('tips', {
            show: true,
            title: '系统出现异常，请及时联系管理员!'
          })
        }
      })
      this.loading = false
    },

    //查询用户性别
    userSex() {
      this.loading = true
      userSex(this.queryParams).then(response => {
        if (response.data) {
          this.isSex=response.data
        } else {
          this.bus.$emit('tips', {
            show: true,
            title: '系统出现异常，请及时联系管理员!'
          })
        }
      })
      this.loading = false
    },
  },

}

</script>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/view/pomelo/app/labor/index.vue